// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-header {
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  background: #222222;
}
ion-header ion-toolbar {
  --background: #222222;
  --color: white;
  --padding-start: 8px;
  --padding-end: 8px;
  --min-height: 64px;
}
ion-header ion-toolbar .header-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
}
ion-header ion-toolbar .header-content .header-logo {
  height: 32px;
  width: auto;
  filter: brightness(0) invert(1);
  display: block;
}
ion-header ion-toolbar .back-btn,
ion-header ion-toolbar .lang-btn {
  --color: white;
  --background-hover: rgba(255, 255, 255, 0.1);
  --background-activated: rgba(255, 255, 255, 0.2);
  --border-radius: 12px;
  --padding-start: 12px;
  --padding-end: 12px;
  margin: 4px;
  z-index: 2;
}
ion-header ion-toolbar .back-btn ion-icon,
ion-header ion-toolbar .lang-btn ion-icon {
  font-size: 22px;
}
ion-header ion-toolbar .lang-btn .lang-icon {
  height: 24px;
  width: 24px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  padding: 2px;
  transition: all 0.2s ease;
}
ion-header ion-toolbar .lang-btn .lang-icon:hover {
  border-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.05);
}

.header-wrap {
  padding: 20px;
}
.header-wrap.with-scan-btn {
  padding-bottom: 120px;
}

.title {
  font-size: 30px;
  font-weight: 700;
  font-family: var(--ion-font-family);
  margin-bottom: 20px;
  max-width: 480px;
  position: relative;
  padding-bottom: 0;
}
.title.with-underline {
  color: #FFFFFF;
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-size: 24px;
  line-height: 1.1;
  padding: 10px 0 16px 0;
}
.title.with-underline::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 51px;
  background: #E30613;
}
.title:not(.with-underline)::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 67px;
  background: #000;
}

.wrapper .venue-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin: 8px auto;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.8);
  width: 100%;
  min-width: 280px;
  max-width: 600px;
  box-sizing: border-box;
}
.wrapper .venue-container:hover:not(.disabled) {
  transform: translateY(-4px);
  box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.12);
  border-color: rgba(var(--ion-color-primary-rgb), 0.2);
}
.wrapper .venue-container.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  filter: grayscale(20%);
}
.wrapper .venue-container.disabled .image-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.wrapper .venue-container .image-container {
  position: relative;
  height: 160px;
  width: 100%;
  overflow: hidden;
}
.wrapper .venue-container .image-container ion-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.wrapper .venue-container .image-container .status-overlay {
  position: absolute;
  bottom: 12px;
  right: 12px;
  z-index: 2;
}
.wrapper .venue-container .image-container .status-overlay .isOpen {
  background: linear-gradient(135deg, #34a853 0%, #137333 100%);
  color: white;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 11px;
  font-family: AppFontBold;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}
.wrapper .venue-container .image-container .status-overlay .isOpen.disabled {
  background: linear-gradient(135deg, #ea4335 0%, #d33b2c 100%);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
}
.wrapper .venue-container .container-info {
  padding: 18px;
  position: relative;
}
.wrapper .venue-container .container-info .address-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 15px;
  border-bottom: 1px solid #f1f3f4;
  margin-bottom: 15px;
}
.wrapper .venue-container .container-info .address-row .info {
  flex: 1;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .venue-address {
  font-family: var(--ion-font-family);
  font-weight: 500 !important;
  font-size: 12px;
  line-height: 16px;
  color: #fff;
  flex: 1;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .map-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  background: #f8f9fa;
  border: 1px solid #e8eaed;
  transition: all 0.2s ease;
  text-decoration: none;
  margin-left: 12px;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .map-icon:hover {
  background: #e8f0fe;
  border-color: rgba(var(--ion-color-primary-rgb), 0.3);
  transform: scale(1.05);
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .map-icon ion-icon {
  height: 18px;
  width: 18px;
  color: #5f6368;
}
.wrapper .venue-container .container-info .address-row .info .venue-address-wrapper .map-icon ion-icon:hover {
  color: var(--ion-color-primary);
}
.wrapper .venue-container .container-info .address-row .venue-info-wrapper {
  display: none;
}
.wrapper .venue-container .container-info .preorder-type {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  border: 1px solid #e8eaed;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.wrapper .venue-container .container-info .preorder-type::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(var(--ion-color-primary-rgb), 0.05) 0%, rgba(var(--ion-color-primary-rgb), 0.02) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.wrapper .venue-container .container-info .preorder-type:hover:not(.disabled) {
  border-color: rgba(var(--ion-color-primary-rgb), 0.4);
  transform: translateY(-2px);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
}
.wrapper .venue-container .container-info .preorder-type:hover:not(.disabled)::before {
  opacity: 1;
}
.wrapper .venue-container .container-info .preorder-type:hover:not(.disabled) .eat-icon {
  transform: scale(1.1);
  color: var(--ion-color-primary);
}
.wrapper .venue-container .container-info .preorder-type.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f5f5f5;
  border-color: #e0e0e0;
}
.wrapper .venue-container .container-info .preorder-type.disabled .eat-icon {
  color: #bdbdbd;
}
.wrapper .venue-container .container-info .preorder-type.disabled .type-title {
  color: #9e9e9e;
}
.wrapper .venue-container .container-info .preorder-type.disabled .type-description {
  color: #bdbdbd;
}
.wrapper .venue-container .container-info .preorder-type.active {
  opacity: 1;
}
.wrapper .venue-container .container-info .preorder-type:not(.active) {
  opacity: 0.7;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item {
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 1;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin-right: 12px;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col .eat-icon {
  width: 24px;
  height: 24px;
  min-width: 20px;
  min-height: 20px;
  color: #5f6368;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info {
  flex: 1;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 18px;
  color: #1a1a1a;
  margin-bottom: 2px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 700;
}
.wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-description {
  font-family: AppFont;
  font-size: 12px;
  line-height: 15px;
  color: #5f6368;
  margin: 0;
}
.wrapper .venue-container .container-info .devider {
  display: none;
}

.loading {
  height: 70vh;
  align-items: center;
  justify-content: center;
}
.loading ion-spinner {
  --color: var(--ion-color-primary);
  width: 48px;
  height: 48px;
}

.location-header {
  background: #231f20;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  padding: 0 20px;
  align-items: center;
}
.location-header .location-title {
  padding-top: 5px;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 20px;
  line-height: 1.1;
  margin: 0;
}
.location-header ion-toolbar {
  --background: transparent;
  --padding-end: 0;
  --padding-start: 0;
  padding-top: 0 !important;
  background: transparent;
}
.location-header ion-toolbar ion-buttons {
  display: flex;
  gap: 7px;
  margin-right: 0;
}
.location-header ion-toolbar ion-button {
  --border-radius: 0;
  --padding-start: 0;
  --padding-end: 0;
  width: 33px;
  height: 33px;
  margin: 0;
  --background: transparent;
  --border-color: transparent;
}
.location-header ion-toolbar ion-button ion-icon {
  font-size: 16px;
  color: #7E7E7E;
}
.location-header ion-toolbar ion-button.active {
  --background: #FFFFFF;
}
.location-header ion-toolbar ion-button.active ion-icon {
  color: #000000;
}
.location-header.figma-style {
  background: #000000;
  padding: 0px 20px;
  border-bottom: 1px solid #383838;
  border-top: 1px solid #383838;
}
.location-header.figma-style ion-toolbar ion-button {
  border: none;
  --background: #383838;
  --background-activated: #383838;
  --background-hover: #383838;
  --background-focused: #383838;
}
.location-header.figma-style ion-toolbar ion-button ion-icon {
  color: #C2C2C2;
}
.location-header.figma-style ion-toolbar ion-button.active {
  --background: #E30613 !important;
  --background-activated: #E30613 !important;
  --background-hover: #E30613 !important;
  --background-focused: #E30613 !important;
}
.location-header.figma-style ion-toolbar ion-button.active ion-icon {
  color: #FFFFFF !important;
}
.location-header.figma-style ion-toolbar {
  --min-height: 52px;
}
.location-header.figma-style .location-title {
  padding-top: 0;
  font-family: EintrachtDisplaySublineCondensed, sans-serif;
  font-weight: 400;
}

ion-content.dark-theme {
  --background: #121212;
}
ion-content.dark-theme .header-wrap {
  padding-top: 20px;
}
ion-content.dark-theme .title {
  font-family: AppFontEintrachtOFC;
  font-size: 24px;
}
ion-content.dark-theme .title.with-underline {
  display: block;
  margin-bottom: 13px;
  padding: 0 0 11px;
}
ion-content.dark-theme .kiosk-card.new-design {
  min-height: 125px;
}
ion-content.dark-theme .kiosk-card.new-design .image-col {
  min-width: 95px;
}
ion-content.dark-theme .kiosk-card.new-design .info .info-header .venue-name {
  line-height: 110%;
}

.kiosk-card {
  background: #414042;
  border-radius: 6px;
  color: var(--ion-color-white);
  cursor: pointer;
  margin-bottom: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  max-height: 340px;
  min-height: 125px;
}
.kiosk-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.kiosk-card ion-img {
  width: 100%;
  height: 100%;
  min-height: 120px;
  object-fit: cover;
  border-radius: 6px 0 0 6px;
}
.kiosk-card.new-design {
  background: #383838;
  display: flex;
  align-items: stretch;
  gap: 20px;
}
.kiosk-card.new-design .image-col {
  flex: 0 0 95px;
  max-width: 95px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 6px 0 0 6px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);
  background: #2e2e2e;
}
.kiosk-card.new-design .image-col ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}
.kiosk-card.new-design .icons-col {
  padding-left: 0;
  padding-right: 0;
}
.kiosk-card.new-design .info {
  flex: 1 1 auto;
  padding: 6px 4px 6px 0;
}
.kiosk-card.new-design .info .info-header .venue-name {
  color: #FFFFFF;
  font-family: EintrachtDisplay, sans-serif;
  font-weight: 400;
  font-size: 18px;
}
.kiosk-card.new-design .info .info-header .venue-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 3px;
  border: 1px solid #fff;
  padding: 5px;
}
.kiosk-card.new-design .info .info-header .venue-badge .badge-icon {
  width: 22px;
  height: 14px;
}
.kiosk-card.new-design .info .info-header .venue-badge .number {
  color: #FFFFFF;
  font-family: "Eintracht Sans OFC", sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 1.1;
  border: none;
  padding: 0;
}
.kiosk-card.new-design .info .info-middle {
  margin-bottom: 8px;
}
.kiosk-card.new-design .info .info-middle .icons-col .icon {
  width: 15px;
  height: auto;
  margin-right: 8px;
  vertical-align: middle;
  min-height: 15px;
  filter: invert(100%);
  display: inline-flex;
}
.kiosk-card.new-design .info .info-middle .distance-col .distance {
  color: #B3B6B9;
  font-family: AppFontEintrachtOFCSans, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  margin: 0;
}
.kiosk-card.new-design .info .address-text {
  font-family: AppFontEintrachtOFCSans, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
}
.kiosk-card:not(.new-design) .info {
  padding: 15px 20px;
}
.kiosk-card:not(.new-design) .number {
  padding: 4px 7px;
}
.kiosk-card:not(.new-design) .icon {
  width: 15px;
  height: auto;
  margin-right: 8px;
  vertical-align: middle;
  min-height: 12px;
  filter: invert(100%);
  display: inline-flex;
}
.kiosk-card:not(.new-design) .venue-badge {
  display: flex;
  max-height: 24px;
}

.scan-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, rgb(18, 18, 18) 40%);
  z-index: 10;
}
.scan-section .scan-btn {
  width: 100%;
  background: #E30613;
  border: none;
  border-radius: 6px;
  padding: 16px 20px;
  color: #FFFFFF;
  font-family: AppFontEintrachtOFCSans, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
  text-align: center;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 12px rgba(227, 6, 19, 0.3);
}
.scan-section .scan-btn:hover {
  background: #b1050f;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(227, 6, 19, 0.4);
}
.scan-section .scan-btn:active {
  transform: translateY(0);
}

ion-content:not(.dark-theme) .scan-section {
  background: none;
}
ion-content:not(.dark-theme) .scan-section .scan-btn {
  background: #231f20;
  font-family: var(--ion-font-family);
  box-shadow: none;
  line-height: 20px;
  max-height: 50px;
}

.stadium {
  --background: #231F20;
}
.stadium .stadium-map-container {
  position: relative;
  width: 100%;
  height: auto;
  padding: 20px 10px 180px 10px;
}
.stadium .stadium-map-container .stadium-img {
  width: 90%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.stadium .stadium-map-container .pin-block {
  position: absolute;
  top: 27%;
  left: 32%;
  transform: translate(-50%, -50%);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  animation: fadeInDown 0.8s ease-out 0.3s both;
}
.stadium .stadium-map-container .pin-block .pin-tooltip {
  background: #FFFFFF;
  color: #231F20;
  padding: 0px 12px;
  padding-top: 6px;
  border: 1px solid #DADADA;
  clip-path: polygon(5px 0, 100% 0, 100% calc(100% - 5px), calc(100% - 5px) 100%, 0 100%, 0 5px);
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 8px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  position: relative;
}
.stadium .stadium-map-container .pin-block .pin-icon {
  width: 40px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}
.stadium .stadium-map-container .kiosk-markers-overlay {
  position: absolute;
  top: 20px;
  left: 5%;
  right: 5%;
  bottom: 180px;
  pointer-events: none;
  z-index: 5;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  pointer-events: all;
  transition: all 0.3s ease;
  padding: 8px 12px;
  border-radius: 4px;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker[data-index="0"] {
  top: 12%;
  right: -3%;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker[data-index="1"] {
  top: 24%;
  right: -1%;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker[data-index="2"] {
  top: 38%;
  right: 0%;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker[data-index="3"] {
  top: 52%;
  right: -1%;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker[data-index="4"] {
  top: 66%;
  right: 1%;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker[data-index="5"] {
  top: 80%;
  right: 1%;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-circle {
  position: relative;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-circle .kiosk-icon-round {
  width: 18px;
  height: 18px;
  background: #414042;
  border-radius: 50%;
  transition: all 0.3s ease;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(35, 31, 32, 0.85);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  padding: 4px 10px;
  border-radius: 3px;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-name {
  color: #B3B6B9;
  font-family: "Eintracht Sans OFC", sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.3;
  margin: 0 0 2px 0;
  white-space: nowrap;
  transition: color 0.3s ease;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-distance {
  color: #7e7e7e;
  font-family: "Eintracht Sans OFC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.2;
  margin: 0;
  white-space: nowrap;
  transition: color 0.3s ease;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-circle {
  position: relative;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-circle::after {
  content: "18 × 18";
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: #007BFF;
  color: #FFFFFF;
  padding: 4px 8px;
  border-radius: 3px;
  font-family: "Eintracht Sans OFC", sans-serif;
  font-weight: 700;
  font-size: 10px;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-circle .kiosk-icon-round {
  background: transparent;
  border: 3px solid #007BFF;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-info {
  background: rgba(0, 123, 255, 0.15);
  border: 1px solid #007BFF;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-info .kiosk-name {
  color: #FFFFFF;
  font-weight: 600;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-info .kiosk-distance {
  color: #FFFFFF;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.active .kiosk-marker-circle .kiosk-icon-round {
  background: #414042;
  border: 2px solid #FFFFFF;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.active .kiosk-marker-info {
  background: rgba(65, 64, 66, 0.95);
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.active .kiosk-marker-info .kiosk-name {
  color: #FFFFFF;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.active .kiosk-marker-info .kiosk-distance {
  color: #B3B6B9;
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker:hover:not(.active):not(.highlighted) {
  transform: scale(1.05);
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker:hover:not(.active):not(.highlighted) .kiosk-marker-info {
  background: rgba(65, 64, 66, 0.95);
}
.stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker:hover:not(.active):not(.highlighted) .kiosk-marker-info .kiosk-name {
  color: #FFFFFF;
}
.stadium .kiosk-detail-card {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  padding: 0;
  background: transparent;
  z-index: 100;
  animation: slideUp 0.4s ease-out;
}
.stadium .kiosk-detail-card .kiosk-card.detail {
  display: flex;
  background: #414042;
  border-radius: 6px;
  padding: 0;
  margin: 0;
  max-width: 600px;
  margin: 0 auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
}
.stadium .kiosk-detail-card .kiosk-card.detail .image-col {
  width: 100px;
  min-width: 100px;
}
.stadium .kiosk-detail-card .kiosk-card.detail .image-col ion-img {
  width: 100%;
  height: 100%;
  min-height: 120px;
  object-fit: cover;
  border-radius: 6px 0 0 6px;
}
.stadium .kiosk-detail-card .kiosk-card.detail .info {
  flex: 1;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.stadium .kiosk-detail-card .kiosk-card.detail .info .info-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.stadium .kiosk-detail-card .kiosk-card.detail .info .info-middle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stadium .kiosk-detail-card .kiosk-card.detail .info .info-middle .icons-col {
  display: flex;
}
.stadium .kiosk-detail-card .kiosk-card.detail .info .info-middle .icons-col .icon {
  width: 16px;
  height: 16px;
}
.stadium .kiosk-detail-card .kiosk-card.detail .info .info-middle .distance {
  color: #B3B6B9;
  font-family: "Eintracht Sans OFC", sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.3;
  margin: 0;
}

.kiosk-markers-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 5;
}
.kiosk-markers-overlay .kiosk-marker {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  pointer-events: all;
  transition: all 0.3s ease;
  padding: 8px 12px;
  border-radius: 4px;
}
.kiosk-markers-overlay .kiosk-marker[data-index="0"] {
  top: 12%;
  right: 18%;
}
.kiosk-markers-overlay .kiosk-marker[data-index="1"] {
  top: 24%;
  right: 12%;
}
.kiosk-markers-overlay .kiosk-marker[data-index="2"] {
  top: 38%;
  right: 8%;
}
.kiosk-markers-overlay .kiosk-marker[data-index="3"] {
  top: 52%;
  right: 10%;
}
.kiosk-markers-overlay .kiosk-marker[data-index="4"] {
  top: 66%;
  right: 14%;
}
.kiosk-markers-overlay .kiosk-marker[data-index="5"] {
  top: 80%;
  right: 20%;
}
.kiosk-markers-overlay .kiosk-marker .kiosk-marker-circle {
  position: relative;
}
.kiosk-markers-overlay .kiosk-marker .kiosk-marker-circle .kiosk-icon-round {
  width: 18px;
  height: 18px;
  background: #414042;
  border-radius: 50%;
  transition: all 0.3s ease;
}
.kiosk-markers-overlay .kiosk-marker .kiosk-marker-info {
  background: rgba(35, 31, 32, 0.85);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  padding: 4px 10px;
  border-radius: 3px;
}
.kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-name {
  color: #B3B6B9;
  font-family: "Eintracht Sans OFC", sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.3;
  margin: 0 0 2px 0;
  white-space: nowrap;
  transition: color 0.3s ease;
}
.kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-distance {
  color: #7e7e7e;
  font-family: "Eintracht Sans OFC", sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: 1.2;
  margin: 0;
  white-space: nowrap;
  transition: color 0.3s ease;
}
.kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-circle {
  position: relative;
}
.kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-circle::after {
  content: "18 × 18";
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: #007BFF;
  color: #FFFFFF;
  padding: 4px 8px;
  border-radius: 3px;
  font-family: "Eintracht Sans OFC", sans-serif;
  font-weight: 700;
  font-size: 10px;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);
}
.kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-circle .kiosk-icon-round {
  background: transparent;
  border: 3px solid #007BFF;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
}
.kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-info {
  background: rgba(0, 123, 255, 0.15);
  border: 1px solid #007BFF;
}
.kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-info .kiosk-name {
  color: #FFFFFF;
  font-weight: 600;
}
.kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-info .kiosk-distance {
  color: #FFFFFF;
}
.kiosk-markers-overlay .kiosk-marker.active .kiosk-marker-circle .kiosk-icon-round {
  background: #414042;
  border: 2px solid #FFFFFF;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
}
.kiosk-markers-overlay .kiosk-marker.active .kiosk-marker-info {
  background: rgba(65, 64, 66, 0.95);
}
.kiosk-markers-overlay .kiosk-marker.active .kiosk-marker-info .kiosk-name,
.kiosk-markers-overlay .kiosk-marker.active .kiosk-marker-info .kiosk-distance {
  color: #FFFFFF;
}
.kiosk-markers-overlay .kiosk-marker:hover:not(.active):not(.highlighted) {
  transform: scale(1.05);
}
.kiosk-markers-overlay .kiosk-marker:hover:not(.active):not(.highlighted) .kiosk-marker-info {
  background: rgba(65, 64, 66, 0.95);
}
.kiosk-markers-overlay .kiosk-marker:hover:not(.active):not(.highlighted) .kiosk-marker-info .kiosk-name {
  color: #FFFFFF;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate(-50%, -120%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -100%);
  }
}
@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .wrapper .venue-container {
    max-width: 400px;
    margin: 12px auto;
  }
  .header-wrap {
    padding: 30px 24px 18px;
  }
  .stadium .stadium-map-container {
    padding: 15px 8px 180px 8px;
  }
  .stadium .stadium-map-container .stadium-img {
    width: 92%;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay {
    top: 15px;
    bottom: 180px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-name {
    font-size: 14px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-distance {
    font-size: 14px;
  }
  .stadium .kiosk-detail-card {
    bottom: 15px;
    left: 15px;
    right: 15px;
  }
}
@media (min-width: 1024px) {
  .wrapper .venue-container {
    max-width: 380px;
    margin-bottom: 28px;
  }
  .wrapper .venue-container .container-info {
    padding: 24px;
  }
  .wrapper .venue-container .container-info .preorder-type {
    padding: 14px 16px;
    margin: 12px 0;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col {
    margin-right: 16px;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col .eat-icon {
    width: 26px;
    height: 26px;
    min-width: 22px;
    min-height: 22px;
    flex-shrink: 0;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-title {
    font-size: 15px;
    line-height: 19px;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-description {
    font-size: 13px;
    line-height: 16px;
  }
  .header-wrap {
    padding: 35px 32px 20px;
  }
  ion-header ion-toolbar {
    --min-height: 68px;
  }
  ion-header ion-toolbar .header-content .header-logo {
    height: 36px;
  }
  ion-header ion-toolbar .back-btn,
  ion-header ion-toolbar .lang-btn {
    --padding-start: 16px;
    --padding-end: 16px;
  }
  ion-header ion-toolbar .back-btn ion-icon,
  ion-header ion-toolbar .lang-btn ion-icon {
    font-size: 24px;
  }
  ion-header ion-toolbar .lang-btn .lang-icon {
    height: 26px;
    width: 26px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker {
    padding: 10px 14px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-circle .kiosk-icon-round {
    width: 20px;
    height: 20px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info {
    padding: 6px 12px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-name {
    font-size: 14px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-distance {
    font-size: 14px;
  }
  .stadium .kiosk-detail-card .kiosk-card.detail .image-col {
    width: 120px;
    min-width: 120px;
  }
  .stadium .kiosk-detail-card .kiosk-card.detail .info {
    padding: 16px 20px;
  }
  .stadium .kiosk-detail-card .kiosk-card.detail .info .info-header .venue-name {
    font-size: 18px;
  }
}
@media (min-width: 991px) {
  .wrapper .venue-container {
    max-width: 750px;
    margin-bottom: 32px;
  }
  .wrapper .venue-container .container-info {
    padding: 28px;
  }
  .wrapper .venue-container .container-info .preorder-type {
    padding: 16px 20px;
    margin: 16px 0;
  }
  .wrapper .venue-container .container-info .preorder-type:hover:not(.disabled) {
    transform: translateY(-3px);
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.12);
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col {
    margin-right: 18px;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .icon-type-col .eat-icon {
    width: 28px;
    height: 28px;
    min-width: 24px;
    min-height: 24px;
    flex-shrink: 0;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-title {
    font-size: 16px;
    line-height: 20px;
  }
  .wrapper .venue-container .container-info .preorder-type .preorder-type-item .type_info .type-description {
    font-size: 14px;
    line-height: 18px;
  }
  .header-wrap {
    padding: 40px 40px 25px;
  }
  ion-header ion-toolbar {
    --min-height: 72px;
  }
  ion-header ion-toolbar .header-content .header-logo {
    height: 40px;
  }
  ion-header ion-toolbar .back-btn,
  ion-header ion-toolbar .lang-btn {
    --padding-start: 18px;
    --padding-end: 18px;
  }
  ion-header ion-toolbar .back-btn ion-icon,
  ion-header ion-toolbar .lang-btn ion-icon {
    font-size: 26px;
  }
  ion-header ion-toolbar .lang-btn .lang-icon {
    height: 28px;
    width: 28px;
  }
}
@media (max-width: 767px) {
  .wrapper .venue-container {
    min-width: 280px;
    max-width: 480px;
    margin: 10px auto;
  }
  .wrapper .venue-container .container-info {
    padding: 16px;
  }
  .wrapper .venue-container .container-info .preorder-type {
    padding: 10px 12px;
    margin: 8px 0;
  }
  .stadium .stadium-map-container {
    padding: 10px 5px 160px 5px;
  }
  .stadium .stadium-map-container .stadium-img {
    width: 95%;
  }
  .stadium .stadium-map-container .pin-block .pin-icon {
    width: 32px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay {
    top: 10px;
    bottom: 160px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker {
    padding: 6px 8px;
    gap: 6px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-circle .kiosk-icon-round {
    width: 18px;
    height: 18px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info {
    padding: 3px 10px;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-name, .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker .kiosk-marker-info .kiosk-distance {
    font-size: 14px;
    line-height: normal;
    margin: 0;
  }
  .stadium .stadium-map-container .kiosk-markers-overlay .kiosk-marker.highlighted .kiosk-marker-circle::after {
    font-size: 8px;
    padding: 3px 6px;
    bottom: -20px;
  }
  .stadium .kiosk-detail-card {
    bottom: 10px;
    left: 10px;
    right: 10px;
  }
  .stadium .kiosk-detail-card .kiosk-card.detail .image-col {
    width: 80px;
    min-width: 80px;
  }
  .stadium .kiosk-detail-card .kiosk-card.detail .image-col ion-img {
    min-height: 100px;
  }
  .stadium .kiosk-detail-card .kiosk-card.detail .info {
    padding: 12px 14px;
    gap: 8px;
  }
  .stadium .kiosk-detail-card .kiosk-card.detail .info .address-row .address-text {
    font-size: 12px;
  }
}
@media (max-width: 480px) {
  .wrapper .venue-container {
    min-width: 260px;
    max-width: 360px;
    margin: 8px auto;
  }
  .wrapper .venue-container .container-info {
    padding: 14px;
  }
  .wrapper .venue-container .container-info .address-row {
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
  .wrapper .venue-container .container-info .preorder-type {
    padding: 8px 10px;
  }
}
/* Wider map (left) + slimmer rail (right) */
.stadium-map-container {
  display: grid;
  grid-template-columns: minmax(0, 68%) 32%;
  /* was: 1fr 320px */
  align-items: center;
  height: 68vh;
  min-height: 520px;
}

/* Stadium image: less zoomed out and centered vertically */
.stadium-img {
  grid-column: 1;
  justify-self: start;
  width: 100%;
  max-width: none;
  object-fit: contain;
  object-position: left center;
  transform: scale(0.98);
  /* was: .86 */
  transform-origin: left center;
  pointer-events: none;
}

.venue-name {
  font-family: var(--ion-font-family);
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  margin-bottom: 4px;
  font-weight: 700;
  margin-top: 0 !important;
}

.address-text {
  font-family: var(--ion-font-family);
  font-size: 12px;
  color: #fff;
  margin-bottom: 4px;
  font-weight: 500;
  line-height: 16px;
  max-height: 32px;
  overflow: overlay;
}

.number {
  border: 1px solid #b3b6b9;
  font-family: var(--ion-font-family);
  font-size: 16px;
  font-weight: 700;
  border-radius: 3px;
}

.distance {
  font-family: var(--ion-font-family);
  font-size: 12px;
  color: #B3B6B9;
  margin-bottom: 4px;
  font-weight: 500;
}

.menu-icon {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.menu-icon .menu-icon-line {
  width: 17px;
  height: 2.17px;
  background-color: #000;
}
.menu-icon .active {
  background-color: #fff !important;
}
.menu-icon .menu-icon-line-eintracht {
  background-color: #fff !important;
}

.number-container {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px;
  border: 1px solid #fff;
  border-radius: 3px;
}

.number-text {
  font-family: var(--ion-font-family);
  font-size: 12px;
  line-height: 1.1;
  font-weight: 700;
  color: #fff;
  padding-top: 3px;
}

/* (optional) give yourself a touch more room on medium screens */
@media (max-width: 520px) {
  .stadium-map-container {
    grid-template-columns: 64% 36%;
  }
  .stadium-img {
    transform: scale(0.94);
  }
}
.kiosk-icons {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.eintracht .info-header .venue-name {
  font-family: EintrachtDisplay, sans-serif;
  font-size: 16px;
}

.info-header {
  gap: 10px;
}

.new-map-stadium {
  display: flex;
  width: 100%;
  height: auto;
  transform: scale(1.1);
  padding-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/select-venue/select-venue.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACC,2CAAA;EACA,mBAAA;AAAD;AAEC;EACC,qBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;AAEE;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,UAAA;EACA,oBAAA;AAAH;AAEG;EACC,YAAA;EACA,WAAA;EACA,+BAAA;EACA,cAAA;AAAJ;AAIE;;EAEC,cAAA;EACA,4CAAA;EACA,gDAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AAFH;AAIG;;EACC,eAAA;AADJ;AAMG;EACC,YAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAJJ;AAMI;EACC,sCAAA;EACA,sBAAA;AAJL;;AAWA;EACC,aAAA;AARD;AAUC;EACC,qBAAA;AARF;;AAYA;EACC,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAVD;AAYC;EACC,cAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAVF;AAYE;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AAVH;AAcC;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAZF;;AAmBC;EACC,iBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,0CAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AAhBF;AAkBE;EACC,2BAAA;EACA,6CAAA;EACA,qDAAA;AAhBH;AAmBE;EACC,YAAA;EACA,mBAAA;EACA,sBAAA;AAjBH;AAoBI;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AAlBL;AAuBE;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AArBH;AAuBG;EACC,YAAA;EACA,WAAA;EACA,iBAAA;AArBJ;AAwBG;EACC,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AAtBJ;AAwBI;EACC,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,0CAAA;EACA,kCAAA;UAAA,0BAAA;AAtBL;AAwBK;EACC,6DAAA;EACA,0CAAA;AAtBN;AA4BE;EACC,aAAA;EACA,kBAAA;AA1BH;AA4BG;EACC,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,oBAAA;EACA,gCAAA;EACA,mBAAA;AA1BJ;AA4BI;EACC,OAAA;AA1BL;AA4BK;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AA1BN;AA4BM;EACC,mCAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;AA1BP;AA6BM;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;AA3BP;AA6BO;EACC,mBAAA;EACA,qDAAA;EACA,sBAAA;AA3BR;AA8BO;EACC,YAAA;EACA,WAAA;EACA,cAAA;AA5BR;AA8BQ;EACC,+BAAA;AA5BT;AAmCI;EACC,aAAA;AAjCL;AAqCG;EACC,0DAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AAnCJ;AAqCI;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+HAAA;EAGA,UAAA;EACA,6BAAA;AArCL;AAwCI;EACC,qDAAA;EACA,2BAAA;EACA,2CAAA;AAtCL;AAwCK;EACC,UAAA;AAtCN;AAyCK;EACC,qBAAA;EACA,+BAAA;AAvCN;AA2CI;EACC,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAzCL;AA2CK;EACC,cAAA;AAzCN;AA4CK;EACC,cAAA;AA1CN;AA6CK;EACC,cAAA;AA3CN;AA+CI;EACC,UAAA;AA7CL;AAgDI;EACC,YAAA;AA9CL;AAiDI;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AA/CL;AAiDK;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AA/CN;AAiDM;EACC,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;AA/CP;AAmDK;EACC,OAAA;AAjDN;AAmDM;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAjDP;AAoDM;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAlDP;AAwDG;EACC,aAAA;AAtDJ;;AA4DA;EACC,YAAA;EACA,mBAAA;EACA,uBAAA;AAzDD;AA2DC;EACC,iCAAA;EACA,WAAA;EACA,YAAA;AAzDF;;AA6DA;EACC,mBAAA;EACA,mCAAA;UAAA,2BAAA;EACA,eAAA;EACA,mBAAA;AA1DD;AA4DC;EACC,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AA1DF;AA6DC;EACC,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AA3DF;AA4DE;EACC,aAAA;EACA,QAAA;EACA,eAAA;AA1DH;AA6DE;EACC,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EAEA,2BAAA;AA5DH;AA8DG;EACC,eAAA;EACA,cAAA;AA5DJ;AA+DG;EACC,qBAAA;AA7DJ;AA+DI;EACC,cAAA;AA7DL;AAmEC;EACK,mBAAA;EACA,iBAAA;EACA,gCAAA;EACH,6BAAA;AAjEH;AAoEG;EACC,YAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,6BAAA;AAlEJ;AAoEI;EACC,cAAA;AAlEL;AAqEI;EACC,gCAAA;EACA,0CAAA;EACA,sCAAA;EACA,wCAAA;AAnEL;AAqEK;EACC,yBAAA;AAnEN;AAyEE;EACC,kBAAA;AAvEH;AA2EE;EACC,cAAA;EACA,yDAAA;EACA,gBAAA;AAzEH;;AA8EA;EACC,qBAAA;AA3ED;AA4EC;EACC,iBAAA;AA1EF;AA4EC;EACC,gCAAA;EACA,eAAA;AA1EF;AA4EE;EACC,cAAA;EACA,mBAAA;EACA,iBAAA;AA1EH;AA6EC;EACC,iBAAA;AA3EF;AA6EE;EACC,eAAA;AA3EH;AA8EE;EACC,iBAAA;AA5EH;;AAiFA;EACC,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,mBAAA;EACA,qDAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AA9ED;AAgFC;EACC,2BAAA;EACA,yCAAA;AA9EF;AAgFC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;AA9EF;AAiFC;EACC,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,SAAA;AA/EF;AAiFE;EACC,cAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,+CAAA;EACA,mBAAA;AAhFH;AAkFG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AAhFJ;AAoFE;EACC,eAAA;EACA,gBAAA;AAlFH;AAqFE;EACC,cAAA;EACA,sBAAA;AAnFH;AAsFI;EACC,cAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;AApFL;AAuFI;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AArFL;AAuFK;EACC,WAAA;EACA,YAAA;AArFN;AAwFK;EACC,cAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AAtFN;AA2FG;EACC,kBAAA;AAzFJ;AA4FK;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;AA1FP;AA+FK;EACC,cAAA;EACA,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AA7FN;AAiGG;EACC,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA/FJ;AAqGE;EACC,kBAAA;AAnGH;AAsGE;EACC,gBAAA;AApGH;AAuGE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;AArGJ;AAwGE;EACC,aAAA;EACA,gBAAA;AAtGH;;AA2GA;EACC,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,gFAAA;EACA,WAAA;AAxGD;AA0GC;EACC,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qDAAA;EACA,4CAAA;AAxGF;AA0GE;EACC,mBAAA;EACA,2BAAA;EACA,4CAAA;AAxGH;AA2GE;EACC,wBAAA;AAzGH;;AA+GE;EACC,gBAAA;AA5GH;AA6GG;EACC,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACG,gBAAA;AA3GP;;AAkHA;EACC,qBAAA;AA/GD;AAiHC;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;AA/GF;AAiHE;EACC,UAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AA/GH;AAkHE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,6CAAA;AAhHH;AAkHG;EACC,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EAEA,yBAAA;EACA,8FAAA;EACA,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AAjHJ;AAgIG;EACC,WAAA;EACA,YAAA;EACA,iDAAA;AA9HJ;AAmIE;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;AAjIH;AAmIG;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAjIJ;AAoII;EACC,QAAA;EACA,UAAA;AAlIL;AAqII;EACC,QAAA;EACA,UAAA;AAnIL;AAsII;EACC,QAAA;EACA,SAAA;AApIL;AAuII;EACC,QAAA;EACA,UAAA;AArIL;AAwII;EACC,QAAA;EACA,SAAA;AAtIL;AAyII;EACC,QAAA;EACA,SAAA;AAvIL;AA0II;EACC,kBAAA;AAxIL;AA0IK;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAxIN;AA4II;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,iBAAA;EACA,kBAAA;AA1IL;AA4IK;EACC,cAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;AA1IN;AA6IK;EACC,cAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;AA3IN;AAiJK;EACC,kBAAA;AA/IN;AAiJM;EACC,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;AA/IP;AAkJM;EACC,uBAAA;EACA,yBAAA;EACA,4CAAA;AAhJP;AAoJK;EACC,mCAAA;EACA,yBAAA;AAlJN;AAoJM;EACC,cAAA;EACA,gBAAA;AAlJP;AAqJM;EACC,cAAA;AAnJP;AA0JK;EACC,mBAAA;EACA,yBAAA;EACA,8CAAA;AAxJN;AA2JK;EACC,kCAAA;AAzJN;AA2JM;EACC,cAAA;AAzJP;AA2JM;EACC,cAAA;AAzJP;AA+JI;EACC,sBAAA;AA7JL;AA+JK;EACC,kCAAA;AA7JN;AA+JM;EACC,cAAA;AA7JP;AAqKC;EACC,eAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gCAAA;AAnKF;AAqKE;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,yCAAA;AAnKH;AAqKG;EACC,YAAA;EACA,gBAAA;AAnKJ;AAqKI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;AAnKL;AAuKG;EACC,OAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AArKJ;AAuKI;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AArKL;AAwKI;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAtKL;AAwKK;EACC,aAAA;AAtKN;AAyKM;EACC,WAAA;EACA,YAAA;AAvKP;AA2KK;EACC,cAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAzKN;;AAkLA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,UAAA;AA/KD;AAiLC;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AA/KF;AAkLE;EACC,QAAA;EACA,UAAA;AAhLH;AAmLE;EACC,QAAA;EACA,UAAA;AAjLH;AAoLE;EACC,QAAA;EACA,SAAA;AAlLH;AAqLE;EACC,QAAA;EACA,UAAA;AAnLH;AAsLE;EACC,QAAA;EACA,UAAA;AApLH;AAuLE;EACC,QAAA;EACA,UAAA;AArLH;AAwLE;EACC,kBAAA;AAtLH;AAwLG;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAtLJ;AA0LE;EACC,kCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,iBAAA;EACA,kBAAA;AAxLH;AA0LG;EACC,cAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;AAxLJ;AA2LG;EACC,cAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;AAzLJ;AA+LG;EACC,kBAAA;AA7LJ;AA+LI;EACC,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;AA7LL;AAgMI;EACC,uBAAA;EACA,yBAAA;EACA,4CAAA;AA9LL;AAkMG;EACC,mCAAA;EACA,yBAAA;AAhMJ;AAkMI;EACC,cAAA;EACA,gBAAA;AAhML;AAmMI;EACC,cAAA;AAjML;AAwMG;EACC,mBAAA;EACA,yBAAA;EACA,8CAAA;AAtMJ;AAyMG;EACC,kCAAA;AAvMJ;AAyMI;;EAEC,cAAA;AAvML;AA6ME;EACC,sBAAA;AA3MH;AA6MG;EACC,kCAAA;AA3MJ;AA6MI;EACC,cAAA;AA3ML;;AAmNA;EACC;IACC,UAAA;IACA,iCAAA;EAhNA;EAmND;IACC,UAAA;IACA,iCAAA;EAjNA;AACF;AAoNA;EACC;IACC,2BAAA;IACA,UAAA;EAlNA;EAqND;IACC,wBAAA;IACA,UAAA;EAnNA;AACF;AAuNA;EAEE;IACC,gBAAA;IACA,iBAAA;EAtND;EAgOD;IACC,uBAAA;EA9NA;EAkOA;IACC,2BAAA;EAhOD;EAkOC;IACC,UAAA;EAhOF;EAmOC;IACC,SAAA;IACA,aAAA;EAjOF;EAqOI;IACC,eAAA;EAnOL;EAsOI;IACC,eAAA;EApOL;EA2OA;IACC,YAAA;IACA,UAAA;IACA,WAAA;EAzOD;AACF;AA6OA;EAEE;IACC,gBAAA;IACA,mBAAA;EA5OD;EA8OC;IACC,aAAA;EA5OF;EA8OE;IACC,kBAAA;IACA,cAAA;EA5OH;EA+OI;IACC,kBAAA;EA7OL;EA+OK;IACC,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;EA7ON;EAkPK;IACC,eAAA;IACA,iBAAA;EAhPN;EAmPK;IACC,eAAA;IACA,iBAAA;EAjPN;EAiQD;IACC,uBAAA;EA/PA;EAmQA;IACC,kBAAA;EAjQD;EAmQC;IACC,YAAA;EAjQF;EAoQC;;IAEC,qBAAA;IACA,mBAAA;EAlQF;EAoQE;;IACC,eAAA;EAjQH;EAqQC;IACC,YAAA;IACA,WAAA;EAnQF;EA0QC;IACC,kBAAA;EAxQF;EA0QE;IACC,WAAA;IACA,YAAA;EAxQH;EA2QE;IACC,iBAAA;EAzQH;EA2QG;IACC,eAAA;EAzQJ;EA4QG;IACC,eAAA;EA1QJ;EAiRC;IACC,YAAA;IACA,gBAAA;EA/QF;EAkRC;IACC,kBAAA;EAhRF;EAkRE;IACC,eAAA;EAhRH;AACF;ACrmCE;ED63CA;IACC,gBAAA;IACA,mBAAA;EArRD;EAuRC;IACC,aAAA;EArRF;EAuRE;IACC,kBAAA;IACA,cAAA;EArRH;EAuRG;IACC,2BAAA;IACA,6CAAA;EArRJ;EAyRI;IACC,kBAAA;EAvRL;EAyRK;IACC,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;EAvRN;EA4RK;IACC,eAAA;IACA,iBAAA;EA1RN;EA6RK;IACC,eAAA;IACA,iBAAA;EA3RN;EA2SD;IACC,uBAAA;EAzSA;EA6SA;IACC,kBAAA;EA3SD;EA6SC;IACC,YAAA;EA3SF;EA8SC;;IAEC,qBAAA;IACA,mBAAA;EA5SF;EA8SE;;IACC,eAAA;EA3SH;EA+SC;IACC,YAAA;IACA,WAAA;EA7SF;AACF;AAkTA;EAEE;IACC,gBAAA;IACA,gBAAA;IACA,iBAAA;EAjTD;EAmTC;IACC,aAAA;EAjTF;EAmTE;IACC,kBAAA;IACA,aAAA;EAjTH;EAwTA;IACC,2BAAA;EAtTD;EAwTC;IACC,UAAA;EAtTF;EA+TE;IACC,WAAA;EA7TH;EAiUC;IACC,SAAA;IACA,aAAA;EA/TF;EAiUE;IACC,gBAAA;IACA,QAAA;EA/TH;EAiUG;IACC,WAAA;IACA,YAAA;EA/TJ;EAkUG;IACC,iBAAA;EAhUJ;EAkUI;IACC,eAAA;IACA,mBAAA;IACM,SAAA;EAhUX;EAoUG;IACC,cAAA;IACA,gBAAA;IACA,aAAA;EAlUJ;EAwUA;IACC,YAAA;IACA,UAAA;IACA,WAAA;EAtUD;EAyUE;IACC,WAAA;IACA,eAAA;EAvUH;EAyUG;IACC,iBAAA;EAvUJ;EA2UE;IACC,kBAAA;IACA,QAAA;EAzUH;EA2UG;IACC,eAAA;EAzUJ;AACF;AAgVA;EAEE;IACC,gBAAA;IACA,gBAAA;IACA,gBAAA;EA/UD;EAiVC;IACC,aAAA;EA/UF;EAiVE;IACC,oBAAA;IACA,mBAAA;EA/UH;EAkVE;IACC,iBAAA;EAhVH;AACF;AAsVA,4CAAA;AACA;EACC,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AApVD;;AAuVA,2DAAA;AACA;EACC,cAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,6BAAA;EACA,oBAAA;AApVD;;AAuVA;EACC,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AApVD;;AAuVA;EACC,mCAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACG,gBAAA;EACA,iBAAA;AApVJ;;AAuVA;EACC,yBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AApVD;;AAuVA;EACC,mCAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AApVD;;AAuVA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AApVD;AAsVC;EACC,WAAA;EACA,cAAA;EACA,sBAAA;AApVF;AAuVC;EACC,iCAAA;AArVF;AAwVC;EACC,iCAAA;AAtVF;;AA0VA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAvVD;;AA0VA;EACC,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAvVD;;AA6VA,iEAAA;AACA;EACC;IACC,8BAAA;EA1VA;EA6VD;IACC,sBAAA;EA3VA;AACF;AA8VA;EACC,eAAA;EACA,gBAAA;EACA,cAAA;AA5VD;;AAgWC;EACC,yCAAA;EACA,eAAA;AA7VF;;AAgWA;EACC,SAAA;AA7VD;;AA+VA;EACC,aAAA;EACG,WAAA;EACA,YAAA;EACA,qBAAA;EACH,iBAAA;AA5VD","sourcesContent":["@import '../../../theme/mixins';\n\nion-header {\n\tbox-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);\n\tbackground: #222222;\n\n\tion-toolbar {\n\t\t--background: #222222;\n\t\t--color: white;\n\t\t--padding-start: 8px;\n\t\t--padding-end: 8px;\n\t\t--min-height: 64px;\n\n\t\t.header-content {\n\t\t\tposition: absolute;\n\t\t\tleft: 50%;\n\t\t\ttop: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\tz-index: 1;\n\t\t\tpointer-events: none;\n\n\t\t\t.header-logo {\n\t\t\t\theight: 32px;\n\t\t\t\twidth: auto;\n\t\t\t\tfilter: brightness(0) invert(1);\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\n\t\t.back-btn,\n\t\t.lang-btn {\n\t\t\t--color: white;\n\t\t\t--background-hover: rgba(255, 255, 255, 0.1);\n\t\t\t--background-activated: rgba(255, 255, 255, 0.2);\n\t\t\t--border-radius: 12px;\n\t\t\t--padding-start: 12px;\n\t\t\t--padding-end: 12px;\n\t\t\tmargin: 4px;\n\t\t\tz-index: 2;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 22px;\n\t\t\t}\n\t\t}\n\n\t\t.lang-btn {\n\t\t\t.lang-icon {\n\t\t\t\theight: 24px;\n\t\t\t\twidth: 24px;\n\t\t\t\tborder: 2px solid rgba(255, 255, 255, 0.3);\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tpadding: 2px;\n\t\t\t\ttransition: all 0.2s ease;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tborder-color: rgba(255, 255, 255, 0.6);\n\t\t\t\t\ttransform: scale(1.05);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.header-wrap {\n\tpadding: 20px;\n\n\t&.with-scan-btn {\n\t\tpadding-bottom: 120px;\n\t}\n}\n\n.title {\n\tfont-size: 30px;\n\tfont-weight: 700;\n\tfont-family: var(--ion-font-family);\n\tmargin-bottom: 20px;\n\t// padding: 10px 0;\n\tmax-width: 480px;\n\tposition: relative;\n\tpadding-bottom: 0;\n\n\t&.with-underline {\n\t\tcolor: #FFFFFF;\n\t\tfont-family: var(--ion-font-family);\n\t\tfont-weight: 700;\n\t\tfont-size: 24px;\n\t\tline-height: 1.1;\n\t\tpadding: 10px 0 16px 0;\n\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\theight: 3px;\n\t\t\twidth: 51px;\n\t\t\tbackground: #E30613;\n\t\t}\n\t}\n\n\t&:not(.with-underline)::after {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\theight: 3px;\n\t\twidth: 67px;\n\t\tbackground: #000;\n\t}\n}\n\n.wrapper {\n\t// padding: 10px 0;\n\n\t.venue-container {\n\t\tbackground: white;\n\t\tborder-radius: 16px;\n\t\tbox-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);\n\t\toverflow: hidden;\n\t\tmargin: 8px auto;\n\t\tcursor: pointer;\n\t\ttransition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\t\tborder: 1px solid rgba(255, 255, 255, 0.8);\n\t\twidth: 100%;\n\t\tmin-width: 280px;\n\t\tmax-width: 600px;\n\t\tbox-sizing: border-box;\n\n\t\t&:hover:not(.disabled) {\n\t\t\ttransform: translateY(-4px);\n\t\t\tbox-shadow: 0px 16px 48px rgba(0, 0, 0, 0.12);\n\t\t\tborder-color: rgba(var(--ion-color-primary-rgb), 0.2);\n\t\t}\n\n\t\t&.disabled {\n\t\t\topacity: 0.6;\n\t\t\tcursor: not-allowed;\n\t\t\tfilter: grayscale(20%);\n\n\t\t\t.image-container {\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbackground: rgba(0, 0, 0, 0.2);\n\t\t\t\t\tz-index: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.image-container {\n\t\t\tposition: relative;\n\t\t\theight: 160px;\n\t\t\twidth: 100%;\n\t\t\toverflow: hidden;\n\n\t\t\tion-img {\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\n\t\t\t.status-overlay {\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: 12px;\n\t\t\t\tright: 12px;\n\t\t\t\tz-index: 2;\n\n\t\t\t\t.isOpen {\n\t\t\t\t\tbackground: linear-gradient(135deg, #34a853 0%, #137333 100%);\n\t\t\t\t\tcolor: white;\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t\tpadding: 6px 12px;\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tletter-spacing: 0.4px;\n\t\t\t\t\tbox-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);\n\t\t\t\t\tbackdrop-filter: blur(4px);\n\n\t\t\t\t\t&.disabled {\n\t\t\t\t\t\tbackground: linear-gradient(135deg, #ea4335 0%, #d33b2c 100%);\n\t\t\t\t\t\tbox-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.container-info {\n\t\t\tpadding: 18px;\n\t\t\tposition: relative;\n\n\t\t\t.address-row {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tpadding-bottom: 15px;\n\t\t\t\tborder-bottom: 1px solid #f1f3f4;\n\t\t\t\tmargin-bottom: 15px;\n\n\t\t\t\t.info {\n\t\t\t\t\tflex: 1;\n\n\t\t\t\t\t.venue-address-wrapper {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\t\tmargin-bottom: 8px;\n\n\t\t\t\t\t\t.venue-address {\n\t\t\t\t\t\t\tfont-family: var(--ion-font-family);\n\t\t\t\t\t\t\tfont-weight: 500 !important;\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tline-height: 16px;\n\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t\tflex: 1;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.map-icon {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\tpadding: 8px;\n\t\t\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\t\t\tbackground: #f8f9fa;\n\t\t\t\t\t\t\tborder: 1px solid #e8eaed;\n\t\t\t\t\t\t\ttransition: all 0.2s ease;\n\t\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t\t\tmargin-left: 12px;\n\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground: #e8f0fe;\n\t\t\t\t\t\t\t\tborder-color: rgba(var(--ion-color-primary-rgb), 0.3);\n\t\t\t\t\t\t\t\ttransform: scale(1.05);\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\tion-icon {\n\t\t\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t\t\t\twidth: 18px;\n\t\t\t\t\t\t\t\tcolor: #5f6368;\n\n\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.venue-info-wrapper {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.preorder-type {\n\t\t\t\tbackground: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);\n\t\t\t\tborder: 1px solid #e8eaed;\n\t\t\t\tborder-radius: 8px;\n\t\t\t\tpadding: 10px 12px;\n\t\t\t\tcursor: pointer;\n\t\t\t\ttransition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\t\t\t\tposition: relative;\n\t\t\t\toverflow: hidden;\n\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbackground: linear-gradient(135deg,\n\t\t\t\t\t\t\trgba(var(--ion-color-primary-rgb), 0.05) 0%,\n\t\t\t\t\t\t\trgba(var(--ion-color-primary-rgb), 0.02) 100%);\n\t\t\t\t\topacity: 0;\n\t\t\t\t\ttransition: opacity 0.3s ease;\n\t\t\t\t}\n\n\t\t\t\t&:hover:not(.disabled) {\n\t\t\t\t\tborder-color: rgba(var(--ion-color-primary-rgb), 0.4);\n\t\t\t\t\ttransform: translateY(-2px);\n\t\t\t\t\tbox-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);\n\n\t\t\t\t\t&::before {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\n\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.disabled {\n\t\t\t\t\topacity: 0.5;\n\t\t\t\t\tcursor: not-allowed;\n\t\t\t\t\tbackground: #f5f5f5;\n\t\t\t\t\tborder-color: #e0e0e0;\n\n\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\tcolor: #bdbdbd;\n\t\t\t\t\t}\n\n\t\t\t\t\t.type-title {\n\t\t\t\t\t\tcolor: #9e9e9e;\n\t\t\t\t\t}\n\n\t\t\t\t\t.type-description {\n\t\t\t\t\t\tcolor: #bdbdbd;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&.active {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\n\t\t\t\t&:not(.active) {\n\t\t\t\t\topacity: 0.7;\n\t\t\t\t}\n\n\t\t\t\t.preorder-type-item {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tz-index: 1;\n\n\t\t\t\t\t.icon-type-col {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tmargin-right: 12px;\n\n\t\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\t\twidth: 24px;\n\t\t\t\t\t\t\theight: 24px;\n\t\t\t\t\t\t\tmin-width: 20px;\n\t\t\t\t\t\t\tmin-height: 20px;\n\t\t\t\t\t\t\tcolor: #5f6368;\n\t\t\t\t\t\t\ttransition: all 0.3s ease;\n\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.type_info {\n\t\t\t\t\t\tflex: 1;\n\n\t\t\t\t\t\t.type-title {\n\t\t\t\t\t\t\tfont-family: AppFontBold;\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\tline-height: 18px;\n\t\t\t\t\t\t\tcolor: #1a1a1a;\n\t\t\t\t\t\t\tmargin-bottom: 2px;\n\t\t\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\t\t\tletter-spacing: 0.3px;\n\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.type-description {\n\t\t\t\t\t\t\tfont-family: AppFont;\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tline-height: 15px;\n\t\t\t\t\t\t\tcolor: #5f6368;\n\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.devider {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.loading {\n\theight: 70vh;\n\talign-items: center;\n\tjustify-content: center;\n\n\tion-spinner {\n\t\t--color: var(--ion-color-primary);\n\t\twidth: 48px;\n\t\theight: 48px;\n\t}\n}\n\n.location-header {\n\tbackground: #231f20;\n\tbackdrop-filter: blur(12px);\n\tpadding: 0 20px;\n\talign-items: center;\n\n\t.location-title {\n\t\tpadding-top: 5px;\n\t\tcolor: #FFFFFF;\n\t\tfont-weight: 500;\n\t\tfont-size: 20px;\n\t\tline-height: 1.1;\n\t\tmargin: 0;\n\t}\n\n\tion-toolbar {\n\t\t--background: transparent;\n\t\t--padding-end: 0;\n\t\t--padding-start: 0;\n\t\tpadding-top: 0!important;\n\t\tbackground: transparent;\n\t\tion-buttons {\n\t\t\tdisplay: flex;\n\t\t\tgap: 7px;\n\t\t\tmargin-right: 0;\n\t\t}\n\n\t\tion-button {\n\t\t\t--border-radius: 0;\n\t\t\t--padding-start: 0;\n\t\t\t--padding-end: 0;\n\t\t\twidth: 33px;\n\t\t\theight: 33px;\n\t\t\tmargin: 0;\n\t\t\t--background: transparent;\n\n\t\t\t--border-color: transparent;\n\n\t\t\tion-icon {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: #7E7E7E\n\t\t\t}\n\n\t\t\t&.active {\n\t\t\t\t--background: #FFFFFF;\n\n\t\t\t\tion-icon {\n\t\t\t\t\tcolor: #000000;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&.figma-style {\n\t\t    background: #000000;\n    \t\tpadding: 0px 20px;\n    \t\tborder-bottom: 1px solid #383838;\n\t\t\tborder-top: 1px solid #383838;\n\n\t\tion-toolbar {\n\t\t\tion-button {\n\t\t\t\tborder: none;\n\t\t\t\t--background: #383838;\n\t\t\t\t--background-activated: #383838;\n\t\t\t\t--background-hover: #383838;\n\t\t\t\t--background-focused: #383838;\n\n\t\t\t\tion-icon {\n\t\t\t\t\tcolor: #C2C2C2;\n\t\t\t\t}\n\n\t\t\t\t&.active {\n\t\t\t\t\t--background: #E30613 !important;\n\t\t\t\t\t--background-activated: #E30613 !important;\n\t\t\t\t\t--background-hover: #E30613 !important;\n\t\t\t\t\t--background-focused: #E30613 !important;\n\n\t\t\t\t\tion-icon {\n\t\t\t\t\t\tcolor: #FFFFFF !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t// Figma: 54px bar (52 + 1px borders)\n\t\tion-toolbar {\n\t\t\t--min-height: 52px;\n\t\t}\n\n\t\t// Figma: Eintracht Display VF, weight 50 = the Subline Condensed instance\n\t\t.location-title {\n\t\t\tpadding-top: 0;\n\t\t\tfont-family: EintrachtDisplaySublineCondensed, sans-serif;\n\t\t\tfont-weight: 400;\n\t\t}\n\t}\n}\n\nion-content.dark-theme {\n\t--background: #121212;\n\t.header-wrap {\n\t\tpadding-top: 20px;\n\t}\n\t.title {\n\t\tfont-family: AppFontEintrachtOFC;\n\t\tfont-size: 24px;\n\n\t\t&.with-underline {\n\t\t\tdisplay: block;\n\t\t\tmargin-bottom: 13px;\n\t\t\tpadding: 0 0 11px;\n\t\t}\n\t}\n\t.kiosk-card.new-design {\n\t\tmin-height: 125px;\n\n\t\t.image-col {\n\t\t\tmin-width: 95px;\n\t\t}\n\n\t\t.info .info-header .venue-name {\n\t\t\tline-height: 110%;\n\t\t}\n\t}\n}\n\n.kiosk-card {\n\tbackground: #414042;\n\tborder-radius: 6px;\n\tcolor: var(--ion-color-white);\n\tcursor: pointer;\n\tmargin-bottom: 10px;\n\ttransition: transform 0.2s ease, box-shadow 0.2s ease;\n\toverflow: hidden;\n\tmax-height: 340px;\n\tmin-height: 125px;\n\n\t&:hover {\n\t\ttransform: translateY(-2px);\n\t\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n\t}\n\tion-img {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tmin-height: 120px;\n\t\tobject-fit: cover;\n\t\tborder-radius: 6px 0 0 6px;\n\t}\n\n\t&.new-design {\n\t\tbackground: #383838;\n\t\tdisplay: flex;\n\t\talign-items: stretch;\n\t\tgap: 20px;\n\n\t\t.image-col {\n\t\t\tflex: 0 0 95px;\n\t\t\tmax-width: 95px;\n\t\t\t// height: 125px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\toverflow: hidden;\n\t\t\tborder-radius: 6px 0 0 6px;\n\t\t\tbox-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);\n\t\t\tbackground: #2e2e2e;\n\n\t\t\tion-img {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t\tborder-radius: inherit;\n\t\t\t}\n\t\t}\n\n\t\t.icons-col {\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\n\t\t.info {\n\t\t\tflex: 1 1 auto;\n\t\t\tpadding: 6px 4px 6px 0;\n\n\t\t\t.info-header {\n\t\t\t\t.venue-name {\n\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\tfont-family: EintrachtDisplay, sans-serif;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t}\n\n\t\t\t\t.venue-badge {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 8px;\n\t\t\t\t\tborder-radius: 3px;\n\t\t\t\t\tborder: 1px solid #fff;\n\t\t\t\t\tpadding: 5px;\n\n\t\t\t\t\t.badge-icon {\n\t\t\t\t\t\twidth: 22px;\n\t\t\t\t\t\theight: 14px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.number {\n\t\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\t\tfont-family: 'Eintracht Sans OFC', sans-serif;\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tline-height: 1.1;\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.info-middle {\n\t\t\t\tmargin-bottom: 8px;\n\n\t\t\t\t.icons-col {\n\t\t\t\t\t.icon {\n\t\t\t\t\t\t\twidth: 15px;\n\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\tmargin-right: 8px;\n\t\t\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\t\t\tmin-height: 15px;\n\t\t\t\t\t\t\tfilter: invert(100%);\n\t\t\t\t\t\t\tdisplay: inline-flex\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.distance-col {\n\t\t\t\t\t.distance {\n\t\t\t\t\t\tcolor: #B3B6B9;\n\t\t\t\t\t\tfont-family: AppFontEintrachtOFCSans, sans-serif;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tline-height: 1.3;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.address-text {\n\t\t\t\tfont-family: AppFontEintrachtOFCSans, sans-serif;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 12px;\n\t\t\t\tline-height: 130%;\n\t\t\t}\n\t\t}\n\t}\n\n\t&:not(.new-design) {\n\t\t.info {\n\t\t\tpadding: 15px 20px;\n\t\t}\n\n\t\t.number {\n\t\t\tpadding: 4px 7px;\n\t\t}\n\n\t\t.icon {\n\t\t\t\twidth: 15px;\n\t\t\t\theight: auto;\n\t\t\t\tmargin-right: 8px;\n\t\t\t\tvertical-align: middle;\n\t\t\t\tmin-height: 12px;\n\t\t\t\tfilter: invert(100%);\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\t// min-width: fit-content;\n\t\t\t}\n\t\t.venue-badge {\n\t\t\tdisplay: flex;\n\t\t\tmax-height: 24px;\n\t\t}\n\t}\n}\n\n.scan-section {\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tpadding: 20px;\n\tbackground: linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, rgba(18, 18, 18, 1) 40%);\n\tz-index: 10;\n\n\t.scan-btn {\n\t\twidth: 100%;\n\t\tbackground: #E30613;\n\t\tborder: none;\n\t\tborder-radius: 6px;\n\t\tpadding: 16px 20px;\n\t\tcolor: #FFFFFF;\n\t\tfont-family: AppFontEintrachtOFCSans, sans-serif;\n\t\tfont-weight: 700;\n\t\tfont-size: 16px;\n\t\tline-height: 1.3;\n\t\ttext-align: center;\n\t\tcursor: pointer;\n\t\ttransition: background 0.3s ease, transform 0.2s ease;\n\t\tbox-shadow: 0 4px 12px rgba(227, 6, 19, 0.3);\n\n\t\t&:hover {\n\t\t\tbackground: darken(#E30613, 10%);\n\t\t\ttransform: translateY(-2px);\n\t\t\tbox-shadow: 0 6px 16px rgba(227, 6, 19, 0.4);\n\t\t}\n\n\t\t&:active {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n}\nion-content{\n&:not(.dark-theme) {\n\t\t.scan-section {\n\t\t\tbackground: none;\n\t\t\t.scan-btn {\n\t\t\t\tbackground: #231f20;\n\t\t\t\tfont-family: var(--ion-font-family);\n\t\t\t\tbox-shadow: none;\n\t\t\t\tline-height: 20px;\n    \t\t\tmax-height: 50px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Stadium location view styles\n.stadium {\n\t--background: #231F20;\n\n\t.stadium-map-container {\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: auto;\n\t\tpadding: 20px 10px 180px 10px; // Add bottom padding for detail card\n\n\t\t.stadium-img {\n\t\t\twidth: 90%; // Zoom out by reducing width\n\t\t\theight: auto;\n\t\t\tdisplay: block;\n\t\t\tmargin: 0 auto; // Center the stadium\n\t\t}\n\n\t\t.pin-block {\n\t\t\tposition: absolute;\n\t\t\ttop: 27%;\n\t\t\tleft: 32%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\tz-index: 10;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-end;\n\t\t\tanimation: fadeInDown 0.8s ease-out 0.3s both;\n\n\t\t\t.pin-tooltip {\n\t\t\t\tbackground: #FFFFFF;\n\t\t\t\tcolor: #231F20;\n\t\t\t\tpadding: 0px 12px;\n\t\t\t\tpadding-top: 6px;\n\t\t\t\t// border-radius: 4px;\n\t\t\t\tborder: 1px solid #DADADA;\n\t\t\t\tclip-path: polygon(5px 0, 100% 0, 100% calc(100% - 5px), calc(100% - 5px) 100%, 0 100%, 0 5px);\n\t\t\t\tfont-family: var(--ion-font-family);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 1.2;\n\t\t\t\tmargin-bottom: 8px;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n\t\t\t\tposition: relative;\n\n\t\t\t\t// &::after {\n\t\t\t\t// \tcontent: '';\n\t\t\t\t// \tposition: absolute;\n\t\t\t\t// \tbottom: -6px;\n\t\t\t\t// \tright: 20px;\n\t\t\t\t// \twidth: 0;\n\t\t\t\t// \theight: 0;\n\t\t\t\t// \tborder-left: 6px solid transparent;\n\t\t\t\t// \tborder-right: 6px solid transparent;\n\t\t\t\t// \tborder-top: 6px solid #FFFFFF;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\t.pin-icon {\n\t\t\t\twidth: 40px;\n\t\t\t\theight: auto;\n\t\t\t\tfilter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));\n\t\t\t}\n\t\t}\n\n\t\t// Kiosk markers overlaid on right edge in oval pattern\n\t\t.kiosk-markers-overlay {\n\t\t\tposition: absolute;\n\t\t\ttop: 20px;\n\t\t\tleft: 5%;\n\t\t\tright: 5%;\n\t\t\tbottom: 180px;\n\t\t\tpointer-events: none;\n\t\t\tz-index: 5;\n\n\t\t\t.kiosk-marker {\n\t\t\t\tposition: absolute;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 8px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tpointer-events: all;\n\t\t\t\ttransition: all 0.3s ease;\n\t\t\t\tpadding: 8px 12px;\n\t\t\t\tborder-radius: 4px;\n\n\t\t\t\t// Position each marker on right edge in oval pattern\n\t\t\t\t&[data-index=\"0\"] {\n\t\t\t\t\ttop: 12%;\n\t\t\t\t\tright: -3%;\n\t\t\t\t}\n\n\t\t\t\t&[data-index=\"1\"] {\n\t\t\t\t\ttop: 24%;\n\t\t\t\t\tright: -1%;\n\t\t\t\t}\n\n\t\t\t\t&[data-index=\"2\"] {\n\t\t\t\t\ttop: 38%;\n\t\t\t\t\tright: 0%;\n\t\t\t\t}\n\n\t\t\t\t&[data-index=\"3\"] {\n\t\t\t\t\ttop: 52%;\n\t\t\t\t\tright: -1%;\n\t\t\t\t}\n\n\t\t\t\t&[data-index=\"4\"] {\n\t\t\t\t\ttop: 66%;\n\t\t\t\t\tright: 1%;\n\t\t\t\t}\n\n\t\t\t\t&[data-index=\"5\"] {\n\t\t\t\t\ttop: 80%;\n\t\t\t\t\tright: 1%;\n\t\t\t\t}\n\n\t\t\t\t.kiosk-marker-circle {\n\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t.kiosk-icon-round {\n\t\t\t\t\t\twidth: 18px;\n\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t\tbackground: #414042;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\ttransition: all 0.3s ease;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.kiosk-marker-info {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 8px;\n\t\t\t\t\tbackground: rgba(35, 31, 32, 0.85);\n\t\t\t\t\tbackdrop-filter: blur(8px);\n\t\t\t\t\tpadding: 4px 10px;\n\t\t\t\t\tborder-radius: 3px;\n\n\t\t\t\t\t.kiosk-name {\n\t\t\t\t\t\tcolor: #B3B6B9;\n\t\t\t\t\t\tfont-family: 'Eintracht Sans OFC', sans-serif;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\t\tline-height: 1.3;\n\t\t\t\t\t\tmargin: 0 0 2px 0;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\ttransition: color 0.3s ease;\n\t\t\t\t\t}\n\n\t\t\t\t\t.kiosk-distance {\n\t\t\t\t\t\tcolor: #7e7e7e;\n\t\t\t\t\t\tfont-family: 'Eintracht Sans OFC', sans-serif;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tline-height: 1.2;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\ttransition: color 0.3s ease;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Highlighted state (blue border with \"18 × 18\" indicator)\n\t\t\t\t&.highlighted {\n\t\t\t\t\t.kiosk-marker-circle {\n\t\t\t\t\t\tposition: relative;\n\n\t\t\t\t\t\t&::after {\n\t\t\t\t\t\t\tcontent: '18 × 18';\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tbottom: -25px;\n\t\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\t\ttransform: translateX(-50%);\n\t\t\t\t\t\t\tbackground: #007BFF;\n\t\t\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\t\t\tpadding: 4px 8px;\n\t\t\t\t\t\t\tborder-radius: 3px;\n\t\t\t\t\t\t\tfont-family: 'Eintracht Sans OFC', sans-serif;\n\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\tbox-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.kiosk-icon-round {\n\t\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\t\tborder: 3px solid #007BFF;\n\t\t\t\t\t\t\tbox-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.kiosk-marker-info {\n\t\t\t\t\t\tbackground: rgba(0, 123, 255, 0.15);\n\t\t\t\t\t\tborder: 1px solid #007BFF;\n\n\t\t\t\t\t\t.kiosk-name {\n\t\t\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.kiosk-distance {\n\t\t\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Active/selected state\n\t\t\t\t&.active {\n\t\t\t\t\t.kiosk-marker-circle .kiosk-icon-round {\n\t\t\t\t\t\tbackground: #414042;\n\t\t\t\t\t\tborder: 2px solid #FFFFFF;\n\t\t\t\t\t\tbox-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);\n\t\t\t\t\t}\n\n\t\t\t\t\t.kiosk-marker-info {\n\t\t\t\t\t\tbackground: rgba(65, 64, 66, 0.95);\n\n\t\t\t\t\t\t.kiosk-name {\n\t\t\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.kiosk-distance {\n\t\t\t\t\t\t\tcolor: #B3B6B9;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Hover state\n\t\t\t\t&:hover:not(.active):not(.highlighted) {\n\t\t\t\t\ttransform: scale(1.05);\n\n\t\t\t\t\t.kiosk-marker-info {\n\t\t\t\t\t\tbackground: rgba(65, 64, 66, 0.95);\n\n\t\t\t\t\t\t.kiosk-name {\n\t\t\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.kiosk-detail-card {\n\t\tposition: fixed;\n\t\tbottom: 20px; // Move up from bottom\n\t\tleft: 20px;\n\t\tright: 20px;\n\t\tpadding: 0;\n\t\tbackground: transparent;\n\t\tz-index: 100;\n\t\tanimation: slideUp 0.4s ease-out;\n\n\t\t.kiosk-card.detail {\n\t\t\tdisplay: flex;\n\t\t\tbackground: #414042;\n\t\t\tborder-radius: 6px;\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\tmax-width: 600px;\n\t\t\tmargin: 0 auto;\n\t\t\tbox-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);\n\n\t\t\t.image-col {\n\t\t\t\twidth: 100px;\n\t\t\t\tmin-width: 100px;\n\n\t\t\t\tion-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tmin-height: 120px;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t\tborder-radius: 6px 0 0 6px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.info {\n\t\t\t\tflex: 1;\n\t\t\t\tpadding: 14px 16px;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 10px;\n\n\t\t\t\t.info-header {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\talign-items: baseline;\n\t\t\t\t}\n\n\t\t\t\t.info-middle {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t.icons-col {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t// gap: 8px;\n\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\twidth: 16px;\n\t\t\t\t\t\t\theight: 16px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.distance {\n\t\t\t\t\t\tcolor: #B3B6B9;\n\t\t\t\t\t\tfont-family: 'Eintracht Sans OFC', sans-serif;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tline-height: 1.3;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Kiosk markers overlaid on the stadium map in oval pattern\n.kiosk-markers-overlay {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tpointer-events: none;\n\tz-index: 5;\n\n\t.kiosk-marker {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tcursor: pointer;\n\t\tpointer-events: all;\n\t\ttransition: all 0.3s ease;\n\t\tpadding: 8px 12px;\n\t\tborder-radius: 4px;\n\n\t\t// Position each marker on the right edge in oval pattern\n\t\t&[data-index=\"0\"] {\n\t\t\ttop: 12%;\n\t\t\tright: 18%;\n\t\t}\n\n\t\t&[data-index=\"1\"] {\n\t\t\ttop: 24%;\n\t\t\tright: 12%;\n\t\t}\n\n\t\t&[data-index=\"2\"] {\n\t\t\ttop: 38%;\n\t\t\tright: 8%;\n\t\t}\n\n\t\t&[data-index=\"3\"] {\n\t\t\ttop: 52%;\n\t\t\tright: 10%;\n\t\t}\n\n\t\t&[data-index=\"4\"] {\n\t\t\ttop: 66%;\n\t\t\tright: 14%;\n\t\t}\n\n\t\t&[data-index=\"5\"] {\n\t\t\ttop: 80%;\n\t\t\tright: 20%;\n\t\t}\n\n\t\t.kiosk-marker-circle {\n\t\t\tposition: relative;\n\n\t\t\t.kiosk-icon-round {\n\t\t\t\twidth: 18px;\n\t\t\t\theight: 18px;\n\t\t\t\tbackground: #414042;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\ttransition: all 0.3s ease;\n\t\t\t}\n\t\t}\n\n\t\t.kiosk-marker-info {\n\t\t\tbackground: rgba(35, 31, 32, 0.85);\n\t\t\tbackdrop-filter: blur(8px);\n\t\t\tpadding: 4px 10px;\n\t\t\tborder-radius: 3px;\n\n\t\t\t.kiosk-name {\n\t\t\t\tcolor: #B3B6B9;\n\t\t\t\tfont-family: 'Eintracht Sans OFC', sans-serif;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tline-height: 1.3;\n\t\t\t\tmargin: 0 0 2px 0;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\ttransition: color 0.3s ease;\n\t\t\t}\n\n\t\t\t.kiosk-distance {\n\t\t\t\tcolor: #7e7e7e;\n\t\t\t\tfont-family: 'Eintracht Sans OFC', sans-serif;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 10px;\n\t\t\t\tline-height: 1.2;\n\t\t\t\tmargin: 0;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\ttransition: color 0.3s ease;\n\t\t\t}\n\t\t}\n\n\t\t// Highlighted state (blue border with \"18 × 18\" indicator)\n\t\t&.highlighted {\n\t\t\t.kiosk-marker-circle {\n\t\t\t\tposition: relative;\n\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: '18 × 18';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbottom: -25px;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\ttransform: translateX(-50%);\n\t\t\t\t\tbackground: #007BFF;\n\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\tpadding: 4px 8px;\n\t\t\t\t\tborder-radius: 3px;\n\t\t\t\t\tfont-family: 'Eintracht Sans OFC', sans-serif;\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\tbox-shadow: 0 2px 8px rgba(0, 123, 255, 0.4);\n\t\t\t\t}\n\n\t\t\t\t.kiosk-icon-round {\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\tborder: 3px solid #007BFF;\n\t\t\t\t\tbox-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.kiosk-marker-info {\n\t\t\t\tbackground: rgba(0, 123, 255, 0.15);\n\t\t\t\tborder: 1px solid #007BFF;\n\n\t\t\t\t.kiosk-name {\n\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\n\t\t\t\t.kiosk-distance {\n\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t// Active/selected state\n\t\t&.active {\n\t\t\t.kiosk-marker-circle .kiosk-icon-round {\n\t\t\t\tbackground: #414042;\n\t\t\t\tborder: 2px solid #FFFFFF;\n\t\t\t\tbox-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);\n\t\t\t}\n\n\t\t\t.kiosk-marker-info {\n\t\t\t\tbackground: rgba(65, 64, 66, 0.95);\n\n\t\t\t\t.kiosk-name,\n\t\t\t\t.kiosk-distance {\n\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t// Hover state\n\t\t&:hover:not(.active):not(.highlighted) {\n\t\t\ttransform: scale(1.05);\n\n\t\t\t.kiosk-marker-info {\n\t\t\t\tbackground: rgba(65, 64, 66, 0.95);\n\n\t\t\t\t.kiosk-name {\n\t\t\t\t\tcolor: #FFFFFF;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Animations\n@keyframes fadeInDown {\n\tfrom {\n\t\topacity: 0;\n\t\ttransform: translate(-50%, -120%);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\ttransform: translate(-50%, -100%);\n\t}\n}\n\n@keyframes slideUp {\n\tfrom {\n\t\ttransform: translateY(100%);\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\ttransform: translateY(0);\n\t\topacity: 1;\n\t}\n}\n\n// Responsive styles\n@media (min-width: 768px) and (max-width: 1023px) {\n\t.wrapper {\n\t\t.venue-container {\n\t\t\tmax-width: 400px;\n\t\t\tmargin: 12px auto;\n\t\t}\n\t}\n\n\t// .title {\n\t// \tfont-size: 30px;\n\t// \tmargin-bottom: 25px;\n\t// \tpadding: 0 24px;\n\t// }\n\n\t.header-wrap {\n\t\tpadding: 30px 24px 18px;\n\t}\n\n\t.stadium {\n\t\t.stadium-map-container {\n\t\t\tpadding: 15px 8px 180px 8px;\n\n\t\t\t.stadium-img {\n\t\t\t\twidth: 92%;\n\t\t\t}\n\n\t\t\t.kiosk-markers-overlay {\n\t\t\t\ttop: 15px;\n\t\t\t\tbottom: 180px;\n\n\t\t\t\t.kiosk-marker {\n\t\t\t\t\t.kiosk-marker-info {\n\t\t\t\t\t\t.kiosk-name {\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.kiosk-distance {\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.kiosk-detail-card {\n\t\t\tbottom: 15px;\n\t\t\tleft: 15px;\n\t\t\tright: 15px;\n\t\t}\n\t}\n}\n\n@media (min-width: 1024px) {\n\t.wrapper {\n\t\t.venue-container {\n\t\t\tmax-width: 380px;\n\t\t\tmargin-bottom: 28px;\n\n\t\t\t.container-info {\n\t\t\t\tpadding: 24px;\n\n\t\t\t\t.preorder-type {\n\t\t\t\t\tpadding: 14px 16px;\n\t\t\t\t\tmargin: 12px 0;\n\n\t\t\t\t\t.preorder-type-item {\n\t\t\t\t\t\t.icon-type-col {\n\t\t\t\t\t\t\tmargin-right: 16px;\n\n\t\t\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\t\t\twidth: 26px;\n\t\t\t\t\t\t\t\theight: 26px;\n\t\t\t\t\t\t\t\tmin-width: 22px;\n\t\t\t\t\t\t\t\tmin-height: 22px;\n\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.type_info {\n\t\t\t\t\t\t\t.type-title {\n\t\t\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t\t\t\tline-height: 19px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.type-description {\n\t\t\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\t\t\tline-height: 16px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// .title {\n\t// \tfont-size: 36px;\n\t// \tmargin-bottom: 30px;\n\t// \tpadding: 0 32px;\n\t// \tmax-width: 700px;\n\t// }\n\n\t.header-wrap {\n\t\tpadding: 35px 32px 20px;\n\t}\n\n\tion-header {\n\t\tion-toolbar {\n\t\t\t--min-height: 68px;\n\n\t\t\t.header-content .header-logo {\n\t\t\t\theight: 36px;\n\t\t\t}\n\n\t\t\t.back-btn,\n\t\t\t.lang-btn {\n\t\t\t\t--padding-start: 16px;\n\t\t\t\t--padding-end: 16px;\n\n\t\t\t\tion-icon {\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.lang-btn .lang-icon {\n\t\t\t\theight: 26px;\n\t\t\t\twidth: 26px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.stadium {\n\t\t.stadium-map-container {\n\t\t\t.kiosk-markers-overlay .kiosk-marker {\n\t\t\t\tpadding: 10px 14px;\n\n\t\t\t\t.kiosk-marker-circle .kiosk-icon-round {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t}\n\n\t\t\t\t.kiosk-marker-info {\n\t\t\t\t\tpadding: 6px 12px;\n\n\t\t\t\t\t.kiosk-name {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.kiosk-distance {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.kiosk-detail-card .kiosk-card.detail {\n\t\t\t.image-col {\n\t\t\t\twidth: 120px;\n\t\t\t\tmin-width: 120px;\n\t\t\t}\n\n\t\t\t.info {\n\t\t\t\tpadding: 16px 20px;\n\n\t\t\t\t.info-header .venue-name {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include desktop {\n\t.wrapper {\n\t\t.venue-container {\n\t\t\tmax-width: 750px;\n\t\t\tmargin-bottom: 32px;\n\n\t\t\t.container-info {\n\t\t\t\tpadding: 28px;\n\n\t\t\t\t.preorder-type {\n\t\t\t\t\tpadding: 16px 20px;\n\t\t\t\t\tmargin: 16px 0;\n\n\t\t\t\t\t&:hover:not(.disabled) {\n\t\t\t\t\t\ttransform: translateY(-3px);\n\t\t\t\t\t\tbox-shadow: 0px 12px 32px rgba(0, 0, 0, 0.12);\n\t\t\t\t\t}\n\n\t\t\t\t\t.preorder-type-item {\n\t\t\t\t\t\t.icon-type-col {\n\t\t\t\t\t\t\tmargin-right: 18px;\n\n\t\t\t\t\t\t\t.eat-icon {\n\t\t\t\t\t\t\t\twidth: 28px;\n\t\t\t\t\t\t\t\theight: 28px;\n\t\t\t\t\t\t\t\tmin-width: 24px;\n\t\t\t\t\t\t\t\tmin-height: 24px;\n\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.type_info {\n\t\t\t\t\t\t\t.type-title {\n\t\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\t\tline-height: 20px;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t.type-description {\n\t\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\t\tline-height: 18px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// .title {\n\t// \tfont-size: 42px;\n\t// \tmargin-bottom: 35px;\n\t// \tpadding: 0 40px;\n\t// \tmax-width: 750px;\n\t// }\n\n\t.header-wrap {\n\t\tpadding: 40px 40px 25px;\n\t}\n\n\tion-header {\n\t\tion-toolbar {\n\t\t\t--min-height: 72px;\n\n\t\t\t.header-content .header-logo {\n\t\t\t\theight: 40px;\n\t\t\t}\n\n\t\t\t.back-btn,\n\t\t\t.lang-btn {\n\t\t\t\t--padding-start: 18px;\n\t\t\t\t--padding-end: 18px;\n\n\t\t\t\tion-icon {\n\t\t\t\t\tfont-size: 26px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.lang-btn .lang-icon {\n\t\t\t\theight: 28px;\n\t\t\t\twidth: 28px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 767px) {\n\t.wrapper {\n\t\t.venue-container {\n\t\t\tmin-width: 280px;\n\t\t\tmax-width: 480px;\n\t\t\tmargin: 10px auto;\n\n\t\t\t.container-info {\n\t\t\t\tpadding: 16px;\n\n\t\t\t\t.preorder-type {\n\t\t\t\t\tpadding: 10px 12px;\n\t\t\t\t\tmargin: 8px 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.stadium {\n\t\t.stadium-map-container {\n\t\t\tpadding: 10px 5px 160px 5px;\n\n\t\t\t.stadium-img {\n\t\t\t\twidth: 95%; // Less zoom out on mobile\n\t\t\t}\n\n\t\t\t.pin-block {\n\t\t\t\t.pin-tooltip {\n\t\t\t\t\t// font-size: 12px;\n\t\t\t\t\t// padding: 6px 10px;\n\t\t\t\t}\n\n\t\t\t\t.pin-icon {\n\t\t\t\t\twidth: 32px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.kiosk-markers-overlay {\n\t\t\t\ttop: 10px;\n\t\t\t\tbottom: 160px;\n\n\t\t\t\t.kiosk-marker {\n\t\t\t\t\tpadding: 6px 8px;\n\t\t\t\t\tgap: 6px;\n\n\t\t\t\t\t.kiosk-marker-circle .kiosk-icon-round {\n\t\t\t\t\t\twidth: 18px;\n\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t}\n\n\t\t\t\t\t.kiosk-marker-info {\n\t\t\t\t\t\tpadding: 3px 10px;\n\n\t\t\t\t\t\t.kiosk-name, .kiosk-distance {\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t\tline-height: normal;\n        \t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t&.highlighted .kiosk-marker-circle::after {\n\t\t\t\t\t\tfont-size: 8px;\n\t\t\t\t\t\tpadding: 3px 6px;\n\t\t\t\t\t\tbottom: -20px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.kiosk-detail-card {\n\t\t\tbottom: 10px;\n\t\t\tleft: 10px;\n\t\t\tright: 10px;\n\n\t\t\t.kiosk-card.detail {\n\t\t\t\t.image-col {\n\t\t\t\t\twidth: 80px;\n\t\t\t\t\tmin-width: 80px;\n\n\t\t\t\t\tion-img {\n\t\t\t\t\t\tmin-height: 100px;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.info {\n\t\t\t\t\tpadding: 12px 14px;\n\t\t\t\t\tgap: 8px;\n\n\t\t\t\t\t.address-row .address-text {\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (max-width: 480px) {\n\t.wrapper {\n\t\t.venue-container {\n\t\t\tmin-width: 260px;\n\t\t\tmax-width: 360px;\n\t\t\tmargin: 8px auto;\n\n\t\t\t.container-info {\n\t\t\t\tpadding: 14px;\n\n\t\t\t\t.address-row {\n\t\t\t\t\tpadding-bottom: 12px;\n\t\t\t\t\tmargin-bottom: 12px;\n\t\t\t\t}\n\n\t\t\t\t.preorder-type {\n\t\t\t\t\tpadding: 8px 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Wider map (left) + slimmer rail (right) */\n.stadium-map-container {\n\tdisplay: grid;\n\tgrid-template-columns: minmax(0, 68%) 32%;\n\t/* was: 1fr 320px */\n\talign-items: center;\n\theight: 68vh;\n\tmin-height: 520px;\n}\n\n/* Stadium image: less zoomed out and centered vertically */\n.stadium-img {\n\tgrid-column: 1;\n\tjustify-self: start;\n\twidth: 100%;\n\tmax-width: none;\n\tobject-fit: contain;\n\tobject-position: left center;\n\ttransform: scale(.98);\n\t/* was: .86 */\n\ttransform-origin: left center;\n\tpointer-events: none;\n}\n\n.venue-name {\n\tfont-family: var(--ion-font-family);\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #fff;\n\tmargin-bottom: 4px;\n\tfont-weight: 700;\n\tmargin-top: 0 !important;\n}\n\n.address-text {\n\tfont-family: var(--ion-font-family);\n\tfont-size: 12px;\n\tcolor: #fff;\n\tmargin-bottom: 4px;\n\tfont-weight: 500;\n\tline-height: 16px;\n    max-height: 32px;\n    overflow: overlay;\n}\n\n.number {\n\tborder: 1px solid #b3b6b9;\n\tfont-family: var(--ion-font-family);\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tborder-radius: 3px;\n}\n\n.distance {\n\tfont-family: var(--ion-font-family);\n\tfont-size: 12px;\n\tcolor: #B3B6B9;\n\tmargin-bottom: 4px;\n\tfont-weight: 500;\n}\n\n.menu-icon {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 3px;\n\n\t.menu-icon-line {\n\t\twidth: 17px;\n\t\theight: 2.17px;\n\t\tbackground-color: #000;\n\t}\n\n\t.active {\n\t\tbackground-color: #fff !important;\n\t}\n\n\t.menu-icon-line-eintracht {\n\t\tbackground-color: #fff !important;\n\t}\n}\n\n.number-container {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 6px;\n\tpadding: 5px;\n\tborder: 1px solid #fff;\n\tborder-radius: 3px;\n}\n\n.number-text {\n\tfont-family: var(--ion-font-family);\n\tfont-size: 12px;\n\tline-height: 1.1;\n\tfont-weight: 700;\n\tcolor: #fff;\n\tpadding-top: 3px;\n}\n\n\n\n\n/* (optional) give yourself a touch more room on medium screens */\n@media (max-width: 520px) {\n\t.stadium-map-container {\n\t\tgrid-template-columns: 64% 36%;\n\t}\n\n\t.stadium-img {\n\t\ttransform: scale(.94);\n\t}\n}\n\n.kiosk-icons {\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tpadding-top: 0;;\n}\n\n.eintracht {\n\t.info-header .venue-name {\n\t\tfont-family: EintrachtDisplay, sans-serif;\n\t\tfont-size: 16px;\n\t}\n}\n.info-header {\n\tgap: 10px\n}\n.new-map-stadium {\n\tdisplay: flex;\n    width: 100%;\n    height: auto;\n    transform: scale(1.1);\n\tpadding-top: 15px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
